export default {
  app: {
    golf: {
      title: 'Laukuma informācija',
      hasEVChargingPoint: 'Elektroauto uzlādes punkts',
      hasCaddieService: 'Kadija pakalpojums',
      hasTrolley: 'Ratiņi',
      hasBuggy: 'Bagijs',
      hasClubRental: 'Nūju noma',
      hasAcademy: 'Akadēmija',
      hasMarshal: 'Maršals',
      hasPGACertification: 'PGA sertifikācija',
      hasTrainingArea: 'Treniņu zona',
      hasRestaurant: 'Restorāns',
      hasHotel: 'Viesnīca',
      hasDogsOnCourse: 'Suņi laukumā',
      numberOfHoles: 'Bedrīšu skaits',
    },
  },
};
